/** @odoo-module **/

import publicWidget from "@web/legacy/js/public/public_widget";
import PortalSidebar from "@portal/js/portal_sidebar";
import { uniqueId } from "@web/core/utils/functions";

publicWidget.registry.PurchasePortalSidebar = PortalSidebar.extend({
    selector: ".o_portal_purchase_sidebar",

    /**
     * @constructor
     */
    init: function (parent, options) {
        this._super.apply(this, arguments);
        this.authorizedTextTag = ["em", "b", "i", "u"];
        this.spyWatched = $('body[data-target=".navspy"]');
        this.orm = this.bindService("orm");
    },
    /**
     * @override
     */
    start: function () {
        var def = this._super.apply(this, arguments);
        var $spyWatcheElement = this.$el.find('[data-id="portal_sidebar"]');
        this._setElementId($spyWatcheElement);
        // Nav Menu ScrollSpy
        this._generateMenu();
        return def;
    },

    //--------------------------------------------------------------------------
    // Private
    //---------------------------------------------------------------------------

    /**
     * create an unique id and added as a attribute of spyWatched element
     *
     * @private
     * @param {string} prefix
     * @param {Object} $el
     *
     */
    _setElementId: function (prefix, $el) {
        var id = uniqueId(prefix);
        this.spyWatched.find($el).attr("id", id);
        return id;
    },
    /**
     * generate the new spy menu
     *
     * @private
     *
     */
    _generateMenu: function () {
        var self = this,
            lastLI = false,
            lastUL = null,
            $bsSidenav = this.$el.find(".bs-sidenav");

        $("#quote_content [id^=quote_header_], #quote_content [id^=quote_]", this.spyWatched).attr(
            "id",
            ""
        );
        this.spyWatched
            .find("#quote_content h2, #quote_content h3")
            .toArray()
            .forEach((el) => {
                var id, text;
                switch (el.tagName.toLowerCase()) {
                    case "h2":
                        id = self._setElementId("quote_header_", el);
                        text = self._extractText($(el));
                        if (!text) {
                            break;
                        }
                        lastLI = $("<li class='nav-item'>")
                            .append(
                                $(
                                    '<a class="nav-link p-0" style="max-width: 200px;" href="#' +
                                        id +
                                        '"/>'
                                ).text(text)
                            )
                            .appendTo($bsSidenav);
                        lastUL = false;
                        break;
                    case "h3":
                        id = self._setElementId("quote_", el);
                        text = self._extractText($(el));
                        if (!text) {
                            break;
                        }
                        if (lastLI) {
                            if (!lastUL) {
                                lastUL = $("<ul class='nav flex-column'>").appendTo(lastLI);
                            }
                            $("<li class='nav-item'>")
                                .append(
                                    $(
                                        '<a class="nav-link p-0" style="max-width: 200px;" href="#' +
                                            id +
                                            '"/>'
                                    ).text(text)
                                )
                                .appendTo(lastUL);
                        }
                        break;
                }
                el.setAttribute("data-anchor", true);
            });
        this.trigger_up("widgets_start_request", { $target: $bsSidenav });
    },
    /**
     * extract text of menu title for sidebar
     *
     * @private
     * @param {Object} $node
     *
     */
    _extractText: function ($node) {
        var self = this;
        var rawText = [];
        Array.from($node.contents()).forEach((el) => {
            var current = $(el);
            if ($.trim(current.text())) {
                var tagName = current.prop("tagName");
                if (
                    typeof tagName === "undefined" ||
                    (typeof tagName !== "undefined" &&
                        self.authorizedTextTag.includes(tagName.toLowerCase()))
                ) {
                    rawText.push($.trim(current.text()));
                }
            }
        });
        return rawText.join(" ");
    },
});
